var map = {
	"./bash": 1734,
	"./java": 1735,
	"./json": 1736,
	"./julia": 1737,
	"./python": 1738,
	"./r": 1739,
	"./rust": 1740,
	"./scala": 1741,
	"./shell": 1742,
	"./sql": 1743,
	"./xml": 1744,
	"./yaml": 1745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1733;